<template>
	<v-form ref="userForm">
		<v-card-text>
			<v-layout wrap>
				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 sm6>
							<v-text-field
								label="Full Name"
								outline
								tabindex="1"
								v-model="form.name"
								name="full_name"
								:hide-details="!errors.has('name')"
								:error="errors.has('name')"
								:error-count="errors.count('name')"
								:error-messages="errors.get('name')"
							></v-text-field>
						</v-flex>

						<v-flex xs12 sm6>
							<v-text-field
								label="Contact Email Address"
								outline
								tabindex="2"
								v-model="form.email"
								name="email"
								:hide-details="!errors.has('email')"
								:error="errors.has('email')"
								:error-count="errors.count('email')"
								:error-messages="errors.get('email')"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>

				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 sm6>
							<v-text-field
								label="Contact Phone"
								outline
								tabindex="3"
								v-model="form.phone"
								name="phone"
								:mask="getPhoneMask"
								:hide-details="!errors.has('phone')"
								:error="errors.has('phone')"
								:error-count="errors.count('phone')"
								:error-messages="errors.get('phone')"
							></v-text-field>
						</v-flex>

						<v-flex xs12 sm6>
							<v-text-field
								label="Company Name"
								outline
								tabindex="4"
								v-model="form.company"
								name="company"
								:hide-details="!errors.has('company')"
								:error="errors.has('company')"
								:error-count="errors.count('company')"
								:error-messages="errors.get('company')"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>

				<v-flex xs12>
					<v-text-field
						label="Street Address"
						outline
						tabindex="5"
						v-model="form.address"
						name="address"
						:hide-details="!errors.has('address')"
						:error="errors.has('address')"
						:error-count="errors.count('address')"
						:error-messages="errors.get('address')"
					></v-text-field>
				</v-flex>

				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 sm6>
							<v-text-field
								label="Street Address 2"
								outline
								tabindex="6"
								v-model="form.address2"
								name="address2"
								:hide-details="!errors.has('address2')"
								:error="errors.has('address2')"
								:error-count="errors.count('address2')"
								:error-messages="errors.get('address2')"
							></v-text-field>
						</v-flex>

						<v-flex xs12 sm6>
							<v-autocomplete
								label="Country"
								outline
								tabindex="7"
								v-model="form.country_code"
								name="country"
								:items="countryList"
								clearable
								item-text="name"
								item-value="abbreviation"
								browser-autocomplete="disabled"
								:hide-details="!errors.has('role_id')"
								:error="errors.has('role_id')"
								:error-count="errors.count('role_id')"
								:error-messages="errors.get('role_id')"
							></v-autocomplete>
						</v-flex>
					</v-layout>
				</v-flex>




				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 sm6>
							<v-text-field
								label="Business Partner Id"
								outline
								tabindex="6"
								v-model="form.business_partner_id"
								name="business_partner_id"
								:hide-details="!errors.has('business_partner_id')"
								:error="errors.has('business_partner_id')"
								:error-count="errors.count('business_partner_id')"
								:error-messages="errors.get('business_partner_id')"
							></v-text-field>
						</v-flex>

						<v-flex xs12 sm6>
							<v-text-field
								label="City"
								outline
								tabindex="8"
								v-model="form.city"
								name="city"
								:hide-details="!errors.has('city')"
								:error="errors.has('city')"
								:error-count="errors.count('city')"
								:error-messages="errors.get('city')"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>


				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 sm6 >
							<v-autocomplete
								label="State"
								outline
								tabindex="9"
								v-model="form.state"
								name="state"
								:items="states"
								item-text="name"
								item-value="abbreviation"
								clearable
								browser-autocomplete="disabled"
								:hide-details="!errors.has('state')"
								:error="errors.has('state')"
								:error-count="errors.count('state')"
								:error-messages="errors.get('state')"
								v-if="states"
							></v-autocomplete>
							<v-text-field
								label="State"
								outline
								tabindex="10"
								v-model="form.state"
								name="state_text"
								:hide-details="!errors.has('state')"
								:error="errors.has('state')"
								:error-count="errors.count('state')"
								:error-messages="errors.get('state')"
								v-else
							></v-text-field>
						</v-flex>

						<v-flex xs12 sm6>
								<v-text-field
								label="Zip Code"
								outline
								tabindex="11"
								v-model="form.zip"
								name="zip"
								:hide-details="!errors.has('zip')"
								:error="errors.has('zip')"
								:error-count="errors.count('zip')"
								:error-messages="errors.get('zip')"
								@blur="forceUppercase('zip')"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
<!--

				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 md4>
							<v-text-field
								label="City"
								outline
								tabindex="8"
								v-model="form.city"
								name="city"
								:hide-details="!errors.has('city')"
								:error="errors.has('city')"
								:error-count="errors.count('city')"
								:error-messages="errors.get('city')"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm6 md4>
							<v-autocomplete
								label="State"
								outline
								tabindex="9"
								v-model="form.state"
								name="state"
								:items="states"
								item-text="name"
								item-value="abbreviation"
								clearable
								browser-autocomplete="disabled"
								:hide-details="!errors.has('state')"
								:error="errors.has('state')"
								:error-count="errors.count('state')"
								:error-messages="errors.get('state')"
								v-if="states"
							></v-autocomplete>
							<v-text-field
								label="State"
								outline
								tabindex="10"
								v-model="form.state"
								name="state_text"
								:hide-details="!errors.has('state')"
								:error="errors.has('state')"
								:error-count="errors.count('state')"
								:error-messages="errors.get('state')"
								v-else
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm6 md4>
							<v-text-field
								label="Zip Code"
								outline
								tabindex="11"
								v-model="form.zip"
								name="zip"
								:hide-details="!errors.has('zip')"
								:error="errors.has('zip')"
								:error-count="errors.count('zip')"
								:error-messages="errors.get('zip')"
								@blur="forceUppercase('zip')"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex> -->

				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 sm6 md4>
							<v-autocomplete
								label="Role"
								outline
								tabindex="12"
								v-model="form.role_id"
								name="role_id"
								:items="ROLES"
								item-text="name"
								item-value="id"
								browser-autocomplete="disabled"
								:hide-details="!errors.has('role_id')"
								:error="errors.has('role_id')"
								:error-count="errors.count('role_id')"
								:error-messages="errors.get('role_id')"
							></v-autocomplete>
						</v-flex>

						<v-flex xs12 md4>
							<v-autocomplete
								label="Supervisor"
								outline
								tabindex="13"
								v-model="form.parent_id"
								name="parent_id"
								cache-items
								:loading="loading"
								:search-input.sync="search"
								:items="parentOptions"
								placeholder="Search for name..."
								item-text="name"
								item-value="id"
								clearable
								browser-autocomplete="disabled"
								:hide-details="!errors.has('parent_id')"
								:error="errors.has('parent_id')"
								:error-count="errors.count('parent_id')"
								:error-messages="errors.get('parent_id')"
							></v-autocomplete>
						</v-flex>

						<v-flex xs12 sm6 md4>
							<v-text-field
								label="Modifier"
								outline
								tabindex="14"
								type="number"
								step="0.1"
								min="0"
								max="1"
								v-model="form.modifier"
								name="modifier"
								:hide-details="!errors.has('modifier')"
								:error="errors.has('modifier')"
								:error-count="errors.count('modifier')"
								:error-messages="errors.get('modifier')"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>

				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 sm6 md4>
							<v-text-field
								label="Stock Wire Rope Hoist - Modifier"
								outline
								tabindex="15"
								type="number"
								step="0.1"
								min="0"
								max="1"
								v-model="form.rope_hoist_modifier"
								name="rope_hoist_modifier"
								:hide-details="
									!errors.has('rope_hoist_modifier')
								"
								:error="errors.has('rope_hoist_modifier')"
								:error-count="
									errors.count('rope_hoist_modifier')
								"
								:error-messages="
									errors.get('rope_hoist_modifier')
								"
							></v-text-field>
						</v-flex>

						<v-flex xs12 sm6 md8>
							<v-autocomplete
								v-model="form.permission_groups"
								item-text="name"
								item-value="id"
								:items="permissionGroups"
								label="Permission Groups"
								placeholder="Select Permission Groups"
								multiple
								hide-details
								:small-chips="$vuetify.breakpoint.smAndUp"
								outline
								clearable
							></v-autocomplete>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-card-text>

		<v-card-actions class="pa-3">
			<v-spacer></v-spacer>
			<v-btn @click="secondaryAction">{{ secondaryActionText }}</v-btn>
			<v-btn color="primary" @click="submit">{{ submitText }}</v-btn>
		</v-card-actions>
	</v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Errors from "@root/helpers/Errors";

export default {
	data() {
		return {
			form: {
				name: "",
				erp_id: "",
				modifier: "",
				rope_hoist_modifier: "",
				company: "",
				role_id: "",
				address: "",
				address2: "",
				country_code: "US",
				city: "",
				state: "",
				zip: "",
				email: "",
				business_partner_id:"",
				phone: "",
				parent_id: "",
				permission_groups: []
			},
			search: "",
			loading: false,
			supervisors: [],
			errors: new Errors()
		};
	},

	computed: {
		...mapGetters(["dark", "currentTeam", "statesList"]),

		...mapGetters("admin", {
			ROLES: "roles"
		}),
		...mapGetters("admin", ["permissionGroups"]),

		getPhoneMask() {
			return ["US", "CA"].indexOf(
				this.getObjectValue("form.country_code", this, "US")
			) > -1
				? "phone"
				: null;
		},

		countryList() {
			return window.Spark.countries;
		},

		states() {
			return this.statesList(
				this.form.country_code ? this.form.country_code : "US"
			);
		},

		secondaryActionText() {
			return this.user ? "Cancel" : "Reset";
		},

		submitText() {
			return this.user ? "Save Changes" : "Create User";
		},

		parentOptions() {
			return this.supervisors;
		}
	},

	methods: {
		...mapActions("admin", {
			CREATE_USER: "createUser",
			UPDATE_USER: "updateUser",
			GET_ROLES: "getRoles"
		}),

		secondaryAction(id) {
			if (this.user) {
				this.$router.back();
				return;
			}

			this.$refs.userForm.reset();
			this.errors.clear();

			if (id) {
				this.$router.push(`/admin/users/${id}`);
			}
		},

		submit() {
			this[this.user ? "updateUser" : "createUser"]
				.call(this)
				.then(data => {
					this.secondaryAction(!this.user ? data.id : false);

					return data;
				})
				.catch(error => {
					error = Object.assign({}, error);
					this.errors.record(error.response.data.errors);
				});
		},

		createUser() {
			return this.CREATE_USER(this.form);
		},

		updateUser() {
			return this.UPDATE_USER({
				form: { ...this.form, parent_id: this.form.parent_id || "" },
				id: this.user.id
			});
		},

		forceUppercase(key) {
			this.form[key] = this.form[key].toUpperCase();
		},

		getSupervisors: _.debounce(function() {
			this.loading = true;
			let role;

			if (this.user) {
				role = this.getObjectValue("role", this.user, "");
			} else {
				role = _.find(this.ROLES, { id: this.form.role_id });
			}

			axios
				.get("/api/users", {
					params: {
						search: this.search,
						supervisors: true,
						role: this.getObjectValue("name", role, "")
					}
				})
				.then(({ data }) => {
					let count = 0;
					while (count < data.length) {
						this.$set(
							this,
							"supervisors",
							_.slice(data, count, (count += 100))
						);
					}
				})
				.finally(() => {
					this.loading = false;
				});
		}, 100)
	},

	props: {
		user: {
			default: false
		}
	},

	created() {
		this.GET_ROLES();

		this.$set(this.form, "role_id", this.currentTeam.default_role_id);
		this.$set(this.form, "modifier", this.currentTeam.default_modifier);
		this.$set(this.form, "country_code", "US");

		if (this.user) {
			const { parent } = this.user;

			if (parent) {
				const { name, id } = parent;

				// need to populate the name to the parent_id for the supervisor
				// field to populate properly.
				this.supervisors.push({ name, id });
			}

			_.forIn(this.form, (value, key) => {
				if (key === "role_id") {
					value = this.getObjectValue("role.id", this.user);
				} else {
					value = this.user[key];

					if (key === "permission_groups") {
						value = _.map(value, "id");
					}
				}

				if (value) {
					this.$set(this.form, key, value);
				}
			});
		}
	},

	watch: {
		"form.country_code": function(value) {
			this.$set(this.form, "state", null);
		},

		search(value, oldValue) {
			if (value !== oldValue && value !== null && value.length >= 3) {
				this.getSupervisors();
			}
		}
	}
};
</script>
